import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
function Infrastructure() {
  useEffect(() => {
    document.title = "Infrastructure -  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>Academics</li>
                <li>Facility</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Facility</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                Carmel Convent has a spacious, well planned building with
                well-ventilated classrooms surrounded by lawns and
                playgrounds.{" "}
              </p>
              <p>
                The Computer labs equipped with the latest computers and
                multimedia technology.{" "}
              </p>
              <p>
                The Audio-Visual Room is equipped both for teaching the students
                and viewing the presentations made by them. The use of audio
                visual aids is well integrated with the school curriculum and
                this room is extensively used by the staff and students
                alike.{" "}
              </p>
              <p>
                The school has a School Library. The reference library which is
                fully computerized and houses over 2,000 books, is a treasure
                trove of information that continues to grow each year. Reading
                sessions are conducted regularly exposing students to good
                written and reading skills.{" "}
              </p>
              <p>
                Carmel has playgrounds, dance room, music room for the children.
                During the activity period these grounds and rooms are used for
                various activities like skating, taekwondo, dance, exercising
                etc.{" "}
              </p>
            </div>
            <div className="facility-section mb-4">
              <h5>1. Library</h5>
              <p>
                <strong>"A Reader Today, A Leader Tomorrow."</strong>
              </p>
              <p>
                The Library at <b>Carmel Convent School, Dharuhera</b> is a
                peaceful and inspiring learning space that nurtures curiosity,
                creativity, and a lifelong love for reading. It serves as a
                gateway to knowledge, encouraging students to explore new ideas,
                broaden their perspectives, and develop independent learning
                habits. Our well-equipped library houses{" "}
                <b>more than 2,500 carefully selected books</b>, including
                storybooks, reference books, encyclopedias, biographies,
                magazines, and subject-specific resources. The collection caters
                to the interests and academic needs of students across all
                grades. Regular reading sessions and storytelling activities
                help cultivate effective reading, writing, and communication
                skills. The library also promotes critical thinking,
                imagination, and research abilities, empowering students to
                become confident and responsible learners. At Carmel Convent
                School, we believe that every book opens the door to new
                possibilities, and our library is a place where young minds
                discover the joy of learning, the power of knowledge, and the
                habit of lifelong reading.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>2. Computer Lab</h5>
              <p>
                Our well-equipped Computer Lab provides students with a modern
                and interactive learning environment to develop essential
                digital skills. Equipped with{" "}
                <b>
                  more than 60 computers, multimedia projectors, LED panels,
                  high-speed internet connectivity, and the latest educational
                  software
                </b>
                , the lab offers hands-on learning in computer applications,
                coding, and information technology. Under the guidance of
                qualified teachers, students enhance their creativity, logical
                thinking, problem-solving skills, and responsible use of
                technology, preparing them to excel in the ever-evolving digital
                world.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>3. Medical Room</h5>
              <p>
                The Medical Room at Carmel Convent School is designed to ensure
                the health, safety, and well-being of every student. It is
                equipped with{" "}
                <b>
                  first-aid facilities, comfortable sick beds, a wheelchair, and
                  essential medical supplies
                </b>{" "}
                to provide immediate care in case of minor illnesses or
                injuries. The school also has{" "}
                <b>ramp accessibility and a lift,</b>
                ensuring quick and safe movement of students in case of illness
                or emergency. Our commitment is to provide a safe, caring, and
                supportive environment where every child's well-being is a
                priority.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>4. Digital Classrooms</h5>
              <p>
                At Carmel Convent School,{" "}
                <b>
                  all classrooms are equipped with smart digital technology,
                  including interactive LED{" "}
                </b>
                panels, to create an engaging and effective learning
                environment. These technology-enabled classrooms make lessons
                more interactive and easier to understand through multimedia
                presentations, educational videos, animations, and digital
                learning resources. By integrating technology into everyday
                teaching, we enhance students' conceptual understanding,
                encourage active participation, and prepare them with the
                digital skills needed for the future.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>5. Dance & Music Room</h5>
              <p>
                The Dance and Music Room at Carmel Convent School provides a
                vibrant and creative space where students discover and nurture
                their artistic talents. Equipped with musical instruments,
                audio-visual facilities, and a spacious practice area, the room
                encourages students to express themselves through music and
                dance. Regular training, performances, and cultural activities
                help develop confidence, creativity, teamwork, and an
                appreciation for India's rich cultural heritage.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>6. CCTV Surveillance Campus</h5>
              <p>
                The safety and security of our students and staff are our
                highest priorities. The entire campus is monitored through a
                comprehensive <b>CCTV surveillance system</b> with{" "}
                <b>more than 104 high-definition (HD) cameras</b> strategically
                installed across classrooms, corridors, playgrounds, entrances,
                and other key areas. The surveillance system operates{" "}
                <b>24 hours a day</b>, ensuring continuous monitoring and
                providing a safe, secure, and disciplined environment for
                learning and growth.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>7. Composite Science Lab</h5>
              <p>
                Our <b>Composite Science Lab</b> is well equipped with a wide
                range of{" "}
                <b>
                  scientific models, laboratory apparatus, and experimental
                  equipment
                </b>{" "}
                for Physics, Chemistry, and Biology. It provides students with
                hands-on learning experiences through practical experiments,
                helping them develop scientific thinking, curiosity, and a
                deeper understanding of concepts.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>8. Transport Facility</h5>
              <p>
                The school provides a{" "}
                <b>safe and reliable transport facility</b>
                through authorized contract-based bus services. Student{" "}
                <b>safety and punctuality</b> are our highest priorities. All
                buses are equipped with the latest safety features, including
                <b>speed governors, first-aid kits, fire extinguishers</b> , and
                are operated by experienced drivers with trained support staff.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>9. Safe Drinking Water (RO System)</h5>
              <p>
                The school is committed to providing{" "}
                <b>clean, safe, and hygienic drinking water </b>to every student
                and staff member. Our campus is equipped with{" "}
                <b>
                  {" "}
                  high-capacity RO (Reverse Osmosis) water purification systems
                </b>
                and <b>water coolers</b>, ensuring a continuous supply of pure,
                safe, and cool drinking water throughout the day. The RO systems
                and water coolers are regularly cleaned, serviced, and
                maintained to uphold the highest standards of hygiene and
                quality. Safe drinking water keeps students healthy, hydrated,
                active, and focused.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>10. Sports Area</h5>
              <p>
                The school provides a spacious and well-maintained{" "}
                <b>Sports Area</b>
                that promotes physical fitness, teamwork, and a healthy
                lifestyle. Students enjoy a <b>basketball court,</b> a large
                <b>playground</b>, and a dedicated <b>children's play zone</b>{" "}
                equipped with <b>swings, slides, and trampolines</b> for young
                learners. Regular sports activities help develop discipline,
                coordination, leadership, and sportsmanship.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>11. Lift</h5>
              <p>
                The school is equipped with a <b>modern lift facility</b> to
                ensure convenience, accessibility, and safety. The lift is
                primarily used for medical emergencies, young children when
                required, and the movement of staff and visitors.
                <b>
                  Students are not permitted to use the lift alone or in groups
                  without the supervision of a staff member.
                </b>
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>12. Fire Safety</h5>
              <p>
                <strong>"Safety is Everyone's Responsibility."</strong>
              </p>
              <p>
                The campus is equipped with{" "}
                <b>
                  fire extinguishers, fire alarms, emergency exits, and other
                  essential fire safety equipment
                </b>{" "}
                in accordance with safety standards. The school conducts{" "}
                <b> fire safety demonstrations and mock drills </b>
                regularly to promote awareness and emergency preparedness among
                students and staff.
              </p>
            </div>

            <div className="facility-section mb-4">
              <h5>13. Taekwondo Training Room</h5>
              <p>
                <strong>"Discipline, Confidence, Strength."</strong>
              </p>
              <p>
                The school has a dedicated <b> Taekwondo Training Room</b>
                equipped with high-quality <b>training mats</b> to ensure safe
                and effective practice. Training is conducted under the guidance
                of a{" "}
                <b>qualified Sports Teacher holding a Black Belt 2nd Dan,</b>
                helping students develop self-discipline, confidence, physical
                fitness, self-defense skills, and sportsmanship.
              </p>
            </div>

            <div className="facility-section">
              <h5>14. Power Backup</h5>
              <p>
                To ensure uninterrupted learning and the smooth functioning of
                the school, the campus is equipped with a{" "}
                <b>powerful generator for power backup</b>. In the event of a
                power outage, the generator provides immediate electricity
                supply, ensuring that classrooms, digital learning facilities,
                laboratories, offices, and other essential services continue to
                operate without disruption.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Infrastructure;
